import { TypedDefinition } from '@rehaje/core'

import type { TypedSchema } from '@rehaje/core'

export class JavaScriptDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'codeRaw',
      type: 'Schema.String'
    },
    {
      name: 'async',
      type: 'Schema.Boolean'
    },
    {
      name: 'iife',
      type: 'Schema.Boolean'
    },
    {
      name: 'jsx',
      type: 'Schema.Boolean'
    },
    {
      name: 'module',
      type: 'Schema.Boolean'
    },
    {
      additionalParameters: {
        name: 'args',
        type: 'Schema.Any'
      },
      name: 'runner',
      return: {
        name: 'result',
        type: 'Schema.Any'
      },
      type: 'Schema.Function'
    }
  ]

  override relationTo = 'Schema.JavaScript'
}
